module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Box3-177af8616ffad7a15a6ef21d9ea8592f.svg";